import Route from '@ember/routing/route'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'

export default class extends Route {
  queryParams = {
    sort: {
      replace: true,
    },
  }

  model() {
    const { uiScope, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    return {
      uiScope,
      period,
    }
  }
}
